var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { isValidObject, KeyPairUnit } from '@airtel/air-design-system';
import { Pressable } from 'react-native';
export var KeyPairUnitWidgetComponent = props => {
  var _a;
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'KeyPairUnitWidget' : _props$testID,
    style = props.style,
    _props$isPressable = props.isPressable,
    isPressable = _props$isPressable === void 0 ? false : _props$isPressable,
    onCopyIconPressMetaData = props.onCopyIconPressMetaData,
    onTertiaryCtaPressMetaData = props.onTertiaryCtaPressMetaData,
    onButtonPressMetaData = props.onButtonPressMetaData,
    onIconButtonPressMetaData = props.onIconButtonPressMetaData,
    onPressMetaData = props.onPressMetaData,
    onUserAction = props.onUserAction,
    id = props.id,
    restProps = __rest(props, ["testID", "style", "isPressable", "onCopyIconPressMetaData", "onTertiaryCtaPressMetaData", "onButtonPressMetaData", "onIconButtonPressMetaData", "onPressMetaData", "onUserAction", "id"]);
  var keyPairJsx = _jsx(KeyPairUnit, Object.assign({
    style: style,
    onCopyIconPress: function onCopyIconPress() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      isValidObject(onCopyIconPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onCopyIconPressMetaData), args));
    },
    onTertiaryCtaPress: function onTertiaryCtaPress() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return isValidObject(onTertiaryCtaPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onTertiaryCtaPressMetaData), args));
    },
    onButtonPress: function onButtonPress() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return isValidObject(onButtonPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onButtonPressMetaData), args));
    },
    onIconButtonPress: function onIconButtonPress() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return isValidObject(onIconButtonPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onIconButtonPressMetaData), args));
    }
  }, restProps, {
    testID: testID
  }));
  if (!((_a = restProps.data) === null || _a === void 0 ? void 0 : _a.length)) return null;
  if (isPressable) {
    return _jsx(Pressable, Object.assign({
      onPress: () => {
        isValidObject(onPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onPressMetaData), props));
      }
    }, {
      children: keyPairJsx
    }));
  }
  return keyPairJsx;
};
KeyPairUnitWidgetComponent.genericRendererKey = 'AirKeyPairUnitWidget';